// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vEt6htHK8VdHShP7OPux{display:flex;gap:10px;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px;white-space:pre-wrap}.vEt6htHK8VdHShP7OPux .kKM7l5IjPoBUqgBdztN0{font-size:10px;color:#8496b9}.vEt6htHK8VdHShP7OPux .poZM4lszoLy7vyZuYfuu{object-fit:contain;width:100%;max-height:400px}.vEt6htHK8VdHShP7OPux .eGxZSJhtHJ0p3bugqd9w{display:flex;justify-content:center;align-items:center;height:100%;padding:1rem;font-size:12px !important}.vEt6htHK8VdHShP7OPux .eGxZSJhtHJ0p3bugqd9w .Ly9gm_y8_LkaFN6k5avs{margin-bottom:1.5rem;line-height:1.6}.vEt6htHK8VdHShP7OPux .eGxZSJhtHJ0p3bugqd9w .Usj82OIj69mW3xfhHMVm{list-style-type:disc;padding-left:2rem;margin:0}.vEt6htHK8VdHShP7OPux .eGxZSJhtHJ0p3bugqd9w .Usj82OIj69mW3xfhHMVm li{margin-bottom:.75rem;line-height:1.4}.vEt6htHK8VdHShP7OPux .eGxZSJhtHJ0p3bugqd9w .vdhZJnk_SKfEvdCf2CPP{line-height:1.6;white-space:pre-wrap}.vEt6htHK8VdHShP7OPux .ljQqzJ_utOET3zI0Z8VO{width:45%;font-size:12px;height:100%;margin-bottom:2rem}.vEt6htHK8VdHShP7OPux .JRTwteD7orj4dvXRWr3R{font-size:1.5rem;font-weight:bold;margin-top:0;margin-bottom:1rem;color:#6e32f0}.vEt6htHK8VdHShP7OPux .OdAwIMPpskc4ttdng3aX{font-size:1rem;line-height:1.5}.vEt6htHK8VdHShP7OPux .m0ccaTWeya6XHM6Z87GA{height:100%;background-color:#e5e5e5;margin:2rem 1rem;width:2px}.vEt6htHK8VdHShP7OPux p{font-size:12px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"slide": `vEt6htHK8VdHShP7OPux`,
	"imgDescription": `kKM7l5IjPoBUqgBdztN0`,
	"image": `poZM4lszoLy7vyZuYfuu`,
	"carouselItem": `eGxZSJhtHJ0p3bugqd9w`,
	"topText": `Ly9gm_y8_LkaFN6k5avs`,
	"bulletPoints": `Usj82OIj69mW3xfhHMVm`,
	"bottomText": `vdhZJnk_SKfEvdCf2CPP`,
	"content": `ljQqzJ_utOET3zI0Z8VO`,
	"title": `JRTwteD7orj4dvXRWr3R`,
	"description": `OdAwIMPpskc4ttdng3aX`,
	"divider": `m0ccaTWeya6XHM6Z87GA`
};
export default ___CSS_LOADER_EXPORT___;
